export const SITE = {
  name: "KeyMaster KFZ",
  legalName: "KeyMaster KFZ – Artur Meier",
  owner: "Thomas Meier",
  tagline: "Chiptuning & Schlüsseldienst im Raum Cloppenburg",
  phoneDisplay: "0160 497 66 72",
  phoneIntl: "+4916049766672",
  email: "info@keymaster-kfz.de",
  whatsapp: "https://wa.me/message/ISRMYH6U5IFDF1",
  address: {
    street: "Brookdamm 7",
    zip: "49688",
    city: "Lastrup",
    country: "Deutschland",
  },
  ustId: "56/129/07059",
  region: "Cloppenburg & Oldenburger Münsterland",
  hours: "Mo–So · 24/7 Notdienst mobil",
  domain: "https://keymaster-kfz.de",
};

export const CAR_BRANDS = [  "AUDI", "BMW", "MERCEDES-BENZ", "VW", "PORSCHE", "OPEL", "FORD", "SEAT",
  "SKODA", "TOYOTA", "RENAULT", "PEUGEOT", "CITROËN", "FIAT", "HYUNDAI",
  "KIA", "MAZDA", "NISSAN", "VOLVO", "TESLA", "DACIA", "SUZUKI",
];

export const SERVICE_AREAS = [
  "Cloppenburg", "Löningen", "Friesoythe", "Emstek", "Garrel", "Lastrup",
  "Molbergen", "Cappeln", "Essen (Oldb.)", "Barßel", "Bösel", "Lindern",
  "Vechta", "Oldenburger Münsterland",
];

export const PARTNERS = [
  {
    name: "Dr-Coding",
    url: "https://dr-coding.de",
    anchor: "Tuning & Software-Files von Dr-Coding",
    tag: "Tuning-Partner",
    desc: "Der Tuner hinter Arturs Abstimmungen: Dr-Coding liefert die geprüften Software-Files und die Basis für unser professionelles Chiptuning.",
  },
  {
    name: "FileSuite",
    url: "https://filesuite.app",
    anchor: "Website & Fahrzeug-Konfigurator von FileSuite",
    tag: "Website & Konfigurator",
    desc: "FileSuite steckt hinter dieser Website und dem Fahrzeug-Konfigurator – moderne Web- und Tuning-Software aus einer Hand.",
  },
];

export const REGIONAL_PARTNERS = [
  { name: "Dr-Coding Cloppenburg", url: "https://cloppenburg.dr-coding.de", anchor: "Tuning & Software-Files Cloppenburg – Dr-Coding" },
  { name: "Dr-File Cloppenburg", url: "https://cloppenburg.dr-file.de", anchor: "Chiptuning-Files Cloppenburg – Dr-File" },
];

// Purchased brand domains (used as sameAs / brand network signal in structured data)
export const BRAND_DOMAINS = [
  "https://keymaster-kfz.de",
  "https://keymaster-clp.de",
  "https://chiptuning-cloppenburg.de",
  "https://coding-cloppenburg.de",
  "https://schluessel-cloppenburg.de",
  "https://tuning.cloppenburg.de",
];

export const STATS = [
  { value: "12+", label: "Jahre Erfahrung" },
  { value: "5.000+", label: "Fahrzeuge betreut" },
  { value: "24/7", label: "Mobiler Notdienst" },
  { value: "60 Min", label: "Ø Reaktionszeit" },
];

export const TESTIMONIALS = [
  {
    name: "Markus H.",
    place: "Cloppenburg",
    text: "Schlüssel komplett verloren, Sonntagabend. Artur war in 45 Minuten da und hat einen neuen Schlüssel direkt am Auto angelernt. Absolut top!",
    service: "KFZ-Schlüssel",
  },
  {
    name: "Sandra K.",
    place: "Löningen",
    text: "Chiptuning an meinem 2.0 TDI – spürbar mehr Drehmoment, sauberer Durchzug und trotzdem sparsam. Professionelle Beratung, ehrliche Ansage.",
    service: "Chiptuning",
  },
  {
    name: "Dennis R.",
    place: "Friesoythe",
    text: "Steuergerät defekt, Werkstatt wollte tauschen für richtig Geld. KeyMaster hat es repariert – Bruchteil des Preises und läuft wieder einwandfrei.",
    service: "Steuergerät-Reparatur",
  },
  {
    name: "Familie Wübbold",
    place: "Emstek",
    text: "Kind im Auto eingeschlossen – Panik pur. Notöffnung ohne Schaden in wenigen Minuten. Ruhig, schnell, kompetent. Danke!",
    service: "Notöffnung",
  },
];

export const HOME_FAQ = [
  {
    q: "In welchem Umkreis seid ihr für mich da?",
    a: "Wir sind mobil im gesamten Raum Cloppenburg unterwegs – inklusive Löningen, Friesoythe, Emstek, Garrel, Lastrup, Molbergen und dem kompletten Oldenburger Münsterland. Auf Anfrage auch darüber hinaus.",
  },
  {
    q: "Was kostet ein Einsatz?",
    a: "Faire, transparente Preise ohne versteckte Kosten. Du erhältst vorab eine klare Ansage, was der Einsatz kostet. Ruf einfach an oder schreib uns über WhatsApp für ein unverbindliches Angebot.",
  },
  {
    q: "Seid ihr wirklich rund um die Uhr erreichbar?",
    a: "Ja. Unser mobiler Notdienst für Autoschlüssel und Notöffnungen ist 24/7 erreichbar – auch an Wochenenden und Feiertagen.",
  },
  {
    q: "Ist Chiptuning legal und schadet es dem Motor?",
    a: "Professionell abgestimmtes Chiptuning bewegt sich innerhalb sicherer Toleranzen und schont bei sachgemäßer Fahrweise den Motor. Wir arbeiten mit erprobten Kennfeldern und beraten dich ehrlich zu Eintragung und Versicherung.",
  },
];
